/* VALNIA — theme.js | JS mínimo, sem dependências externas */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var trapStack = [];
  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  /* ---------- Overlay + Drawers ---------- */
  var overlay = null;
  function getOverlay() {
    if (!overlay) {
      overlay = document.querySelector('[data-overlay]');
      if (overlay) overlay.addEventListener('click', closeAllDrawers);
    }
    return overlay;
  }
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var ov = getOverlay();
    if (ov) ov.classList.add('is-active');
    lockScroll(true);
    trapStack.push(el);
    var f = el.querySelector('button, [href], input, select, textarea');
    if (f) f.focus();
  }
  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var ov = getOverlay();
    if (ov) ov.classList.remove('is-active');
    lockScroll(false);
    trapStack = [];
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      e.preventDefault();
      openDrawer(document.getElementById(open.getAttribute('data-drawer-open')));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeAllDrawers();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  /* ---------- Announcement bar close ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-announcement-close]');
    if (!btn) return;
    var bar = btn.closest('.announcement');
    if (bar) bar.remove();
    try { sessionStorage.setItem('v-announcement-closed', '1'); } catch (err) {}
  });
  try {
    if (sessionStorage.getItem('v-announcement-closed') === '1') {
      var ab = document.querySelector('.announcement[data-dismissible]');
      if (ab) ab.remove();
    }
  } catch (err) {}

  /* ---------- Header search toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var box = document.querySelector('[data-search-box]');
    if (!box) return;
    box.classList.toggle('is-open');
    if (box.classList.contains('is-open')) {
      var i = box.querySelector('input[type="search"]');
      if (i) i.focus();
    }
  });

  /* ---------- Menu mobile (painéis) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-panel-open]');
    if (t) {
      e.preventDefault();
      var p = document.getElementById(t.getAttribute('data-panel-open'));
      if (p) {
        p.classList.add('is-open');
        var root = t.closest('[data-menu-root]');
        if (root) root.hidden = true;
      }
      return;
    }
    var b = e.target.closest('[data-panel-back]');
    if (b) {
      e.preventDefault();
      var panel = b.closest('.menu-panel');
      if (panel) panel.classList.remove('is-open');
      var r = document.querySelector('[data-menu-root]');
      if (r) r.hidden = false;
    }
  });

  /* ---------- Collapsible (accordion acessível, animado) ---------- */
  class VCollapse extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.collapse__trigger');
      this.panel = this.querySelector('.collapse__panel');
      if (!this.trigger || !this.panel) return;
      this.open = this.hasAttribute('open');
      this.panel.style.height = this.open ? 'auto' : '0px';
      this.trigger.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      this.trigger.addEventListener('click', this.toggle.bind(this));
    }
    toggle() {
      this.open = !this.open;
      this.classList.toggle('is-open', this.open);
      this.trigger.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      var h = this.panel.firstElementChild ? this.panel.firstElementChild.offsetHeight : 0;
      if (this.open) {
        this.panel.style.height = h + 'px';
        var self = this;
        this.panel.addEventListener('transitionend', function handler() {
          self.panel.style.height = 'auto';
          self.panel.removeEventListener('transitionend', handler);
        });
      } else {
        this.panel.style.height = h + 'px';
        requestAnimationFrame(function () {
          this.panel.style.height = '0px';
        }.bind(this));
      }
    }
  }
  customElements.define('v-collapse', VCollapse);

  /* ---------- Slider (scroll-snap + setas + dots) ---------- */
  class VSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.slider__track');
      if (!this.track) return;
      this.prev = this.querySelector('.slider__nav--prev');
      this.next = this.querySelector('.slider__nav--next');
      this.dots = this.querySelectorAll('.slider__dot');
      if (this.prev) this.prev.addEventListener('click', this.scrollBy.bind(this, -1));
      if (this.next) this.next.addEventListener('click', this.scrollBy.bind(this, 1));
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      this.dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var s = this.track.children[i];
          if (s) this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }.bind(this));
      }.bind(this));
      this.onScroll();
    }
    slideWidth() {
      var s = this.track.firstElementChild;
      if (!s) return this.track.clientWidth;
      var gap = parseFloat(getComputedStyle(this.track).columnGap || 0) || 0;
      return s.offsetWidth + gap;
    }
    scrollBy(dir) {
      this.track.scrollBy({ left: dir * this.slideWidth(), behavior: 'smooth' });
    }
    onScroll() {
      var t = this.track;
      var max = t.scrollWidth - t.clientWidth - 2;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
      if (this.next) this.next.disabled = t.scrollLeft >= max;
      if (this.dots.length) {
        var idx = Math.round(t.scrollLeft / this.slideWidth());
        this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
    }
  }
  customElements.define('v-slider', VSlider);

  /* ---------- Galeria do produto ---------- */
  class VGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('[data-gallery-slides]');
      this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
      if (!this.slides) return;
      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { this.goTo(i); }.bind(this));
      }.bind(this));
      this.slides.addEventListener('scroll', this.sync.bind(this), { passive: true });
      this.observeVideos();
    }
    goTo(i) {
      var s = this.slides.children[i];
      if (s) this.slides.scrollTo({ left: s.offsetLeft - this.slides.offsetLeft, behavior: 'smooth' });
      this.setCurrent(i);
    }
    setCurrent(i) {
      this.thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    sync() {
      var w = this.slides.firstElementChild ? this.slides.firstElementChild.offsetWidth : 1;
      this.setCurrent(Math.round(this.slides.scrollLeft / w));
    }
    observeVideos() {
      var vids = this.querySelectorAll('video[data-autoplay]');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }
  customElements.define('v-gallery', VGallery);

  /* ---------- Reels (play/pause + som) ---------- */
  document.addEventListener('click', function (e) {
    var reel = e.target.closest('[data-reel]');
    if (!reel) return;
    if (e.target.closest('[data-reel-sound]')) {
      var vs = reel.querySelector('video');
      if (vs) {
        vs.muted = !vs.muted;
        reel.classList.toggle('is-unmuted', !vs.muted);
      }
      return;
    }
    if (e.target.closest('a')) return;
    var v = reel.querySelector('video');
    if (!v) return;
    if (v.paused) { v.play().catch(function () {}); reel.classList.add('is-playing'); }
    else { v.pause(); reel.classList.remove('is-playing'); }
  });

  /* ---------- Autoplay de vídeos visíveis (economia de dados) ---------- */
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.dataset.src && !v.src) { v.src = v.dataset.src; }
          v.play().then(function () { var r = v.closest('[data-reel]'); if (r) r.classList.add('is-playing'); }).catch(function () {});
        } else {
          v.pause();
          var r2 = v.closest('[data-reel]');
          if (r2) r2.classList.remove('is-playing');
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('video[data-lazy-autoplay]').forEach(function (v) { vio.observe(v); });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); rio.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { rio.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Quantidade ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    val += b.getAttribute('data-qty') === 'up' ? 1 : -1;
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Seleção de variante ---------- */
  class VVariants extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form') || document.getElementById('ProductForm');
      this.idInput = this.form ? this.form.querySelector('[name="id"]') : null;
      try { this.data = JSON.parse(this.querySelector('[data-variants-json]').textContent); } catch (e) { this.data = []; }
      this.addEventListener('change', this.onChange.bind(this));
    }
    selected() {
      return Array.from(this.querySelectorAll('input:checked')).map(function (i) { return i.value; });
    }
    onChange() {
      var opts = this.selected();
      var match = this.data.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (this.idInput) this.idInput.value = match.id;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: match } }));
    }
  }
  customElements.define('v-variants', VVariants);

  function priceMarkup(v) {
    var html = '';
    var onSale = v.pct && v.pct > 0;
    if (onSale) html += '<s class="price__compare">' + v.compare + '</s>';
    html += '<span class="price__current">' + v.price + '</span>';
    if (onSale) html += '<span class="price__pct">-' + v.pct + '%</span>';
    return html;
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail.variant;
    document.querySelectorAll('[data-price-target]').forEach(function (el) {
      el.innerHTML = priceMarkup(v);
      el.classList.toggle('price--on-sale', !!(v.pct && v.pct > 0));
    });
    document.querySelectorAll('[data-atc-label]').forEach(function (el) {
      el.textContent = v.available ? el.getAttribute('data-label-available') : el.getAttribute('data-label-soldout');
    });
    document.querySelectorAll('[data-atc-button]').forEach(function (b) { b.disabled = !v.available; });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  class VProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.btn = this.form.querySelector('[data-atc-button]');
      this.err = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
    onSubmit(e) {
      e.preventDefault();
      if (this.btn) { this.btn.classList.add('is-loading'); this.btn.disabled = true; }
      if (this.err) this.err.hidden = true;
      var fd = new FormData(this.form);
      fd.append('sections', 'cart-drawer');
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { throw new Error(data.description || data.message); }
          refreshCart(data);
        }.bind(this))
        .catch(function (err) {
          if (this.err) { this.err.textContent = err.message; this.err.hidden = false; }
        }.bind(this))
        .finally(function () {
          if (this.btn) { this.btn.classList.remove('is-loading'); this.btn.disabled = false; }
        }.bind(this));
    }
  }
  customElements.define('v-product-form', VProductForm);

  function refreshCart(addData) {
    var html = addData && addData.sections && addData.sections['cart-drawer'];
    var drawer = document.getElementById('CartDrawer');
    if (html && drawer) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-content]');
      var target = drawer.querySelector('[data-cart-drawer-content]');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    }
    updateCartCount();
    if (drawer) openDrawer(drawer);
  }

  function updateCartCount() {
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        });
      })
      .catch(function () {});
  }
  window.VALNIA = { refreshCart: refreshCart, updateCartCount: updateCartCount, openDrawer: openDrawer, closeDrawers: closeAllDrawers };

  /* ---------- Alterar quantidade no carrinho ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var onCartPage = document.body.classList.contains('template-cart');
    var line = input.getAttribute('data-line');
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: parseInt(input.value, 10), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (onCartPage) { window.location.reload(); return; }
        var html = data.sections && data.sections['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var target = document.querySelector('#CartDrawer [data-cart-drawer-content]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        }
        updateCartCount();
      })
      .catch(function () { window.location.reload(); });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    var line = rm.getAttribute('data-cart-remove');
    var input = document.querySelector('[data-cart-qty][data-line="' + line + '"]');
    if (input) { input.value = 0; input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ---------- Sticky ATC ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    sio.observe(anchor);
  }

  /* ---------- Editor do tema ---------- */
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
